/* eslint-disable class-methods-use-this */
import React, { Fragment } from 'react'

import axios from 'axios'
import Cookies from 'js-cookie'
import {
  bool, number, string, object,
} from 'prop-types'

import Layout from 'Pods/Profile/Layout/Layout'
import UploadProcess from 'Pods/Profile/Products/BatchUploader/Components/UploadProcess'
import CgdreamBanner from 'Pods/Shared/Banner/CgdreamBanner'
import NewWildcatBanner from 'Pods/Shared/Banner/NewWildcatBanner'
import I18n from 'Pods/Shared/I18n'
import Loader from 'Pods/Shared/Loader'
import TableHeaders from 'Pods/Shared/Table/TableHeaders'
import withRouter from 'Pods/Shared/withRouter'

import buildVerificationFilters from 'Utils/buildVerificationFilters'
import showErrorNotification from 'Utils/showErrorNotification'

import ActiveFilters from './ActiveFilters'
import DashboardSummary from './Components/DashboardSummary'
import { getListingHeaders } from './Components/helpers/ListingHelpers'
import ImageRestore from './Components/ImageRestore/ImageRestore'
import KodamaNotice from './Components/KodamaNotice'
import NextStepsOverlay from './Components/NextStepsOverlay'
import EmptyContent from './EmptyContent'
import FiltersAndBulkActions from './FiltersAndBulkActions'
import Pagination from './Pagination'
import Table from './Table'
import UploadInitiatedModal from './UploadInitiatedModal'

class Listing extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      profileData: null,
      uploadProcessCompleted: false,
      data: [],
      meta: null,
      isDataFetched: false,
      fetchError: false,
      filtersUsed: false,
      filters: this.getPreferredFilters(),
      statuses: this.getModelStatuses(),
      headers:
        getListingHeaders(props.cgtStandardEnabled, props.isSalesBoostEnabled, props.isSubscriptionColumnEnabled),
      selectedRows: [],
      showOnlySelected: false,
      successModalIsOpen:
        this.props.history.action === 'PUSH'
        && this.props.location.state
        && this.props.location.state.batchUploadId > 0,
      editableCollectionId: '',
      isAddingToCollection: false,
      nextStepsOverlayIsOpen: this.props.location.search === '?first_time=1',
      kodamaNoticeClosed: JSON.parse(Cookies.get('kodama_notice_set') || false),
      urlFiltersApplied: false,
    }

    // The cancel token is unmount-only, so overlapping fetches all run to completion.
    // Only the newest may write state: a slower one landing last would otherwise replace
    // fresh rows with stale ones, or hide the table behind fetchError.
    this.lastRequestId = 0

    this.onModelUploadComplete = this.onModelUploadComplete.bind(this)
    this.onUploadProcessComplete = this.onUploadProcessComplete.bind(this)
    this.onUploadProcessCancel = this.onUploadProcessCancel.bind(this)
    this.onFiltersChange = this.onFiltersChange.bind(this)
    this.clearFilters = this.clearFilters.bind(this)
    this.removeFilter = this.removeFilter.bind(this)
    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.onCheckboxClick = this.onCheckboxClick.bind(this)
    this.onSelectAll = this.onSelectAll.bind(this)
    this.closeSuccessModal = this.closeSuccessModal.bind(this)
    this.editCollection = this.editCollection.bind(this)
    this.onShowSelectedTrigger = this.onShowSelectedTrigger.bind(this)
    this.triggerAddToCollection = this.triggerAddToCollection.bind(this)
    this.showNextStepsOverlay = this.showNextStepsOverlay.bind(this)
    this.closeNextStepsOverlay = this.closeNextStepsOverlay.bind(this)
    this.handleCloseNotice = this.handleCloseNotice.bind(this)
    this.fetchProfileData = this.fetchProfileData.bind(this)
    this.onCampaignSubmitted = this.onCampaignSubmitted.bind(this)
    this.handleBodyScroll = this.handleBodyScroll.bind(this)
    this.headerScrollRef = React.createRef()
    this.bodyScrollRef = React.createRef()
  }

  // Syncs the fixed header horizontal scroll with the scrollable table body,
  // so column headers stay aligned when the user scrolls horizontally.
  handleBodyScroll() {
    if (this.headerScrollRef.current && this.bodyScrollRef.current) {
      this.headerScrollRef.current.scrollLeft = this.bodyScrollRef.current.scrollLeft
    }
  }

  fetchProfileData() {
    const { newRoyaltyUi } = this.props
    if (newRoyaltyUi) {
      window.axios
        .get('/api/internal/seller_dashboard/profile', { cancelToken: this.cancelSource.token })
        .then((response) => {
          this.setState({
            profileData: response.data,
          })
        })
        .catch((error) => {
          if (axios.isCancel(error)) {
            return
          }

          if (error.response && window.Sentry) {
            window.Sentry.captureException(error)
          }
        })
    }
  }

  getColgroup() {
    const { isSalesBoostEnabled, isSubscriptionColumnEnabled } = this.props

    const base = isSalesBoostEnabled
      ? ['4%', '7%', '9%', '9%', '10%', '8%', '5%', '7%', '8%', '8%', '8%', '8%', '9%']
      : ['4%', '7%', '11%', '11%', '12%', '9%', '4%', '7%', '9%', '9%', '9%']

    if (isSubscriptionColumnEnabled) {
      // Insert 8% Subscription column before the last (Actions) column
      return [...base.slice(0, -1), '8%', base[base.length - 1]]
    }

    return base
  }

  getDefaultFilters(type = '') {
    return {
      page: 1,
      perPage: 20,
      status: [],
      type,
      fileType: [],
      query: '',
      sortBy: ['updated_at', 'desc'],
      cgtStandard: {},
    }
  }

  getModelStatuses() {
    return [
      {
        value: 'published',
        label: 'Published',
        icon: 'check-circle',
        class: 'text-green',
      },
      {
        value: 'suspended',
        label: 'Suspended',
        icon: 'times-circle',
        class: 'text-warning',
      },
      {
        value: 'draft',
        label: 'Draft',
        icon: 'exclamation-circle',
        class: 'text-default',
      },
      {
        value: 'restricted',
        label: 'Restricted',
        icon: 'exclamation-circle',
        class: 'text-warning',
      },
      {
        value: 'pending',
        label: 'Pending',
        icon: 'question-circle',
        class: 'text-orange',
      },
    ]
  }

  getVerificationFiltersFromUrl() {
    const params = new URLSearchParams(this.props.location.search)
    const verificationFilters = params.getAll('verification_filter[]')
    return verificationFilters.length > 0 ? verificationFilters : null
  }

  getPreferredFilters() {
    let filters = {}

    try {
      filters = JSON.parse(localStorage.getItem('profile/products/filters')) || {}
    } catch (e) { }

    return {
      ...this.getDefaultFilters(),
      perPage: filters.perPage || 20,
    }
  }

  updateUrlWithFilters(filters) {
    const params = new URLSearchParams()

    const vf = buildVerificationFilters(filters.cgtStandard)
    const values = Array.isArray(vf) ? vf : vf ? [vf] : []

    Array.from(new Set(values)).forEach((value) => {
      params.append('verification_filter[]', value)
    })

    const queryString = params.toString()
    const newUrl = `${window.location.pathname}${queryString ? `?${queryString}` : ''}`

    window.history.replaceState({}, '', newUrl)
  }

  setPreferredFilters(filters) {
    localStorage.setItem('profile/products/filters', JSON.stringify(filters))
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    const urlVerificationFilters = this.getVerificationFiltersFromUrl()
    let filters = this.state.filters

    if (urlVerificationFilters && urlVerificationFilters.length > 0) {
      const cgtStandardFromUrl = {}
      urlVerificationFilters.forEach((f) => {
        const [type, value] = f.split(':')
        if (!cgtStandardFromUrl[type]) cgtStandardFromUrl[type] = []
        cgtStandardFromUrl[type].push(value)
      })

      filters = {
        ...filters,
        cgtStandard: {
          ...(filters.cgtStandard || {}),
          ...cgtStandardFromUrl,
        },
      }

      this.setState({ filters, urlFiltersApplied: true })
    }

    this.fetchData(filters, this.state.showOnlySelected)
    this.fetchProfileData()
  }


  componentWillUnmount() {
    this.cancelSource.cancel()
  }

  componentDidUpdate(prevProps) {
    const { cgtStandardEnabled, isSalesBoostEnabled } = this.props
    if (prevProps.cgtStandardEnabled !== cgtStandardEnabled || prevProps.isSalesBoostEnabled !== isSalesBoostEnabled) {
      this.setState({
        headers: getListingHeaders(cgtStandardEnabled, isSalesBoostEnabled),
      })
    }
  }

  showNextStepsOverlay() {
    this.setState({ nextStepsOverlayIsOpen: true })
  }

  closeNextStepsOverlay() {
    this.setState({ nextStepsOverlayIsOpen: false })
  }


  fetchData(filters, showOnlySelected) {
    const { selectedRows } = this.state
    const urlVerificationFilters = this.getVerificationFiltersFromUrl()

    this.lastRequestId += 1
    const requestId = this.lastRequestId

    this.setState({
      fetchError: false,
      filtersUsed:
        filters.page > 1
        || filters.fileType.length > 0
        || filters.status.length > 0
        || filters.query.length > 0
        || (filters.cgtStandard && Object.keys(filters.cgtStandard).length > 0)
        || (urlVerificationFilters && urlVerificationFilters.length > 0),
    })

    const selectedIds = selectedRows.map((row) => row.id)
    const verificationFilter = buildVerificationFilters(filters.cgtStandard)

    const params = {
      ...filters,
      ids: showOnlySelected ? selectedIds : [],
    }

    const combinedFilters = []

    if (verificationFilter) {
      combinedFilters.push(...(Array.isArray(verificationFilter) ? verificationFilter : [verificationFilter]))
    }

    if (!this.state.urlFiltersApplied && urlVerificationFilters) {
      combinedFilters.push(...urlVerificationFilters)
    }

    if (combinedFilters.length > 0) {
      const uniqueFilters = Array.from(new Set(combinedFilters))
      params['verification_filter[]'] = uniqueFilters
    }

    // Remove cgtStandard from params as it's not needed in the API call
    delete params.cgtStandard

    const payload = {
      params,
      cancelToken: this.cancelSource.token,
    }

    axios
      .get('/api/internal/items/my', payload)
      .then((response) => {
        if (requestId !== this.lastRequestId) return

        this.onFetchSuccess(response)
      })
      .catch((error) => {
        if (axios.isCancel(error)) {
          return
        }

        // A dropped connection is the visitor's network, not a defect.
        if (error.response && window.Sentry) {
          window.Sentry.captureException(error)
        }

        if (requestId !== this.lastRequestId) return

        showErrorNotification(I18n.t('profile.my_models.errors.load_failed', { ns: 'rails' }), false)
        this.setState({ fetchError: true, isDataFetched: true })
      })
  }

  onFetchSuccess(response) {
    this.setState({
      data: response.data.data,
      meta: response.data.meta,
      isDataFetched: true,
      fetchError: false,
    })
  }

  onUploadProcessComplete() {
    this.setState({ uploadProcessCompleted: true })
  }

  onUploadProcessCancel() {
    this.setState({ uploadProcessCompleted: true })
  }

  onModelUploadComplete(modelData) {
    this.setState({ data: [modelData, ...this.state.data] })
  }

  uploadProcessIsInProgress() {
    return (
      this.props.location.state
      && this.props.location.state.batchUploadId
      && this.props.history.action === 'PUSH'
      && !this.state.uploadProcessCompleted
    )
  }

  onFiltersChange(newFilters) {
    newFilters = newFilters || this.state.filters

    this.setState({ filters: newFilters, isDataFetched: false }, () => {
      this.setPreferredFilters(newFilters)
      this.updateUrlWithFilters(newFilters)
      this.fetchData(newFilters, this.state.showOnlySelected)
    })
  }

  clearFilters() {
    this.onFiltersChange(
      this.getDefaultFilters(
        this.state.isAddingToCollection ? 'collection' : ''
      )
    )
  }

  removeFilter(filterValue, filterName) {
    const newState = this.state
    newState.filters.page = 1

    if (filterName === 'query') {
      newState.filters[filterName] = this.state.filters[filterName]
        .replace(filterValue, '')
        .trim()
    } else {
      newState.filters[filterName] = this.state.filters[filterName].filter(
        (i) => i !== filterValue
      )
    }

    this.setState(newState)
    this.onFiltersChange(this.state.filters)
  }

  onCheckboxClick(id) {
    const model = this.state.selectedRows.filter((item) => item.id === id)

    if (model.length > 0) {
      this.setState((prevState) => ({
        selectedRows: prevState.selectedRows.filter((item) => item.id !== id),
      }))
    } else {
      const model = this.state.data.filter((item) => item.id === id)
      const list = this.state.selectedRows

      list.push(model[0])

      this.setState({ selectedRows: list })
    }
  }

  areAllCurrentPageItemsSelected() {
    const { data, selectedRows } = this.state
    if (data.length === 0) return false

    const selectedIds = new Set(selectedRows.map((row) => row.id))
    return data.every((item) => selectedIds.has(item.id))
  }

  onSelectAll() {
    const allCurrentPageSelected = this.areAllCurrentPageItemsSelected()

    if (allCurrentPageSelected) {
      // Deselect only current page items, preserve other selections
      const currentPageIds = new Set(this.state.data.map((item) => item.id))
      const remainingSelections = this.state.selectedRows.filter(
        (row) => !currentPageIds.has(row.id)
      )
      this.setState({ selectedRows: remainingSelections })
    } else {
      // Add current page items to existing selections (no duplicates)
      const selectedIds = new Set(this.state.selectedRows.map((row) => row.id))
      const newSelections = [...this.state.selectedRows]

      this.state.data.forEach((item) => {
        if (!selectedIds.has(item.id)) {
          newSelections.push(item)
        }
      })
      this.setState({ selectedRows: newSelections })
    }
  }

  onShowSelectedTrigger(name, showOnlySelected) {
    this.setState({ showOnlySelected })

    this.fetchData(this.state.filters, showOnlySelected)
  }

  closeSuccessModal() {
    this.setState({ successModalIsOpen: false })
  }

  editCollection(id) {
    this.setState({ editableCollectionId: id })
  }

  triggerAddToCollection() {
    const newState = this.state
    newState.isAddingToCollection = !this.state.isAddingToCollection
    newState.filters.type = newState.isAddingToCollection ? 'collection' : ''

    this.setState(newState)
    this.onFiltersChange(this.state.filters)
  }

  handleCloseNotice() {
    Cookies.set('kodama_notice_set', true)

    this.setState({ kodamaNoticeClosed: true })
  }

  onCampaignSubmitted() {
    this.fetchData(this.state.filters, this.state.showOnlySelected)
  }

  render() {
    const hasRestrictedModels = this.state.data.some(
      (model) => model.attributes.status === 'restricted'
    )
    const { profileData, meta, fetchError } = this.state

    return (
      <div className="profile-models">
        <Layout
          activeBreadcrumb="My Models"
          showNextStepsOverlay={this.showNextStepsOverlay}
          newRoyaltyUi={this.props.newRoyaltyUi}
          withBoostingPoints={this.props.isSalesBoostEnabled}
          boostCredits={this.props.salesBoostPoints}
        >
          <div style={{ clear: 'both' }} />
          {this.props.imageRestoreEnabled && <ImageRestore />}
          {!this.state.kodamaNoticeClosed && (
            <KodamaNotice
              style={{ marginTop: '20px' }}
              onClose={this.handleCloseNotice}
            />
          )}

          {
            hasRestrictedModels && (
              <>
                <h1 className="text-warning cgt-mb-0">
                  Some of your models have been restricted
                </h1>
                <h3 className="cgt-mt-0">
                  Find out more about it{' '}
                  <a
                    href="https://www.cgtrader.com/blog/cgtrader-suspends-services-in-russia-and-belarus-in-support-of-ukraine"
                    target="_blank"
                    rel="noreferrer"
                  >
                    here
                  </a>
                </h3>
              </>
            )
          }

          {profileData && <DashboardSummary meta={meta} data={profileData} />}

          {this.state.meta && (
            <div className="products-filtering">
              <FiltersAndBulkActions
                onFiltersChange={this.onFiltersChange}
                filters={this.state.filters}
                meta={this.state.meta}
                disableFilters={
                  this.state.data.length === 0 && !this.state.filtersUsed
                }
                selectedItems={this.state.selectedRows}
                editableCollectionId={this.state.editableCollectionId}
                editCollection={this.editCollection}
                isAddingToCollection={this.state.isAddingToCollection}
                triggerAddToCollection={this.triggerAddToCollection}
                onShowSelectedTrigger={this.onShowSelectedTrigger}
                showOnlySelected={this.state.showOnlySelected}
                clearSelection={() => this.setState({ selectedRows: [] })}
                cgtStandardFiltersEnabled={this.props.cgtStandardFiltersEnabled}
              />
              {(this.state.filtersUsed || this.state.isAddingToCollection) && (
                <ActiveFilters
                  onFiltersChange={this.onFiltersChange}
                  filters={this.state.filters}
                  meta={this.state.meta}
                  disableFilters={this.state.data.length === 0 && !this.state.filtersUsed}
                  selectedItems={this.state.selectedRows}
                  editableCollectionId={this.state.editableCollectionId}
                  editCollection={this.editCollection}
                  isAddingToCollection={this.state.isAddingToCollection}
                  triggerAddToCollection={this.triggerAddToCollection}
                  onShowSelectedTrigger={this.onShowSelectedTrigger}
                  showOnlySelected={this.state.showOnlySelected}
                  clearSelection={() => this.setState({ selectedRows: [] })}
                  isSalesBoostEnabled={this.props.isSalesBoostEnabled}
                  salesBoostPoints={this.props.salesBoostPoints}
                  clearFilters={this.clearFilters}
                />
              )}
              {this.state.data.length > 0 && (
                <div ref={this.headerScrollRef} style={{ overflowX: 'hidden' }}>
                  <table width="100%" className="table-with-borders" style={{ minWidth: 1600, tableLayout: 'fixed' }}>
                    <colgroup>
                      {this.getColgroup().map((col, id) => (
                        <col key={id + col} style={{ width: col }} />
                      ))}
                    </colgroup>
                    <TableHeaders
                      headers={this.state.headers}
                      selectAll={
                        this.state.isAddingToCollection ? null : this.onSelectAll
                      }
                      sortingChange={this.onFiltersChange}
                      sortingFilters={this.state.filters}
                      isSelected={this.areAllCurrentPageItemsSelected()}
                    />
                  </table>
                </div>
              )}
            </div>
          )}

          {!fetchError && (
            !this.state.isDataFetched ? (
              <Loader />
            ) : this.state.data.length === 0 ? (
              <EmptyContent filtersUsed={this.state.filtersUsed} />
            ) : (
              <Fragment>
                <div ref={this.bodyScrollRef} style={{ overflowX: 'auto' }} onScroll={this.handleBodyScroll}>
                  <Table
                    data={this.state.data}
                    statuses={this.state.statuses}
                    colgroup={this.getColgroup()}
                    tableMinWidth={1600}
                    onCheckboxClick={this.onCheckboxClick}
                    selectedRows={this.state.selectedRows}
                    allowToDeleteModels={this.state.meta.allowToDeleteModels}
                    editCollection={this.editCollection}
                    isAddingToCollection={this.state.isAddingToCollection}
                    cgtStandardEnabled={this.props.cgtStandardEnabled}
                    userSegment={this.props.userSegment}
                    isDownloadMyModelsEnabled={this.props.isDownloadMyModelsEnabled}
                    isSalesBoostEnabled={this.props.isSalesBoostEnabled}
                    isSubscriptionColumnEnabled={this.props.isSubscriptionColumnEnabled}
                    salesBoostPoints={this.props.salesBoostPoints}
                    limitTagCampaignsAndCostInflation={this.props.limitTagCampaignsAndCostInflation}
                    onCampaignSubmitted={this.onCampaignSubmitted}
                    sellerSuspensionAppealsEnabled={this.props.sellerSuspensionAppealsEnabled}
                  />
                </div>
                {this.state.meta && (
                  <Pagination
                    onFiltersChange={this.onFiltersChange}
                    filters={this.state.filters}
                    meta={this.state.meta}
                  />
                )}
              </Fragment >
            )
          )}

          <div className="row">
            <div className="col-12 col-lg-6">
              <NewWildcatBanner />
            </div>
            <div className="col-12 col-lg-6">
              <CgdreamBanner />
            </div>
          </div>
          {this.props.location.state
            && this.props.location.state.batchUploadId && (
              <UploadInitiatedModal
                modalIsOpen={this.state.successModalIsOpen}
                modelsCount={this.props.location.state.modelsToUpload.length}
                closeModal={this.closeSuccessModal}
              />
            )
          }

          {this.uploadProcessIsInProgress() && (
            <UploadProcess
              batchUploadId={this.props.location.state.batchUploadId}
              modelsToUpload={this.props.location.state.modelsToUpload}
              onModelUploadComplete={this.onModelUploadComplete}
              onUploadProcessComplete={this.onUploadProcessComplete}
              onUploadProcessCancel={this.onUploadProcessCancel}
            />
          )}
          <NextStepsOverlay
            userId={this.props.userId || 0}
            modalIsOpen={this.state.nextStepsOverlayIsOpen}
            closeModal={this.closeNextStepsOverlay}
          />
        </Layout >
      </div >
    )
  }
}

Listing.propTypes = {
  cgtStandardEnabled: bool,
  cgtStandardFiltersEnabled: bool,
  userId: number,
  userSegment: string,
  isDownloadMyModelsEnabled: bool,
  newRoyaltyUi: bool,
  history: object,
  location: object,
  action: string,
  isSalesBoostEnabled: bool,
  imageRestoreEnabled: bool,
  isSubscriptionColumnEnabled: bool,
  salesBoostPoints: number,
  limitTagCampaignsAndCostInflation: bool,
  sellerSuspensionAppealsEnabled: bool,
}

Listing.defaultProps = {
  history: {},
  location: {},
  action: '',
  cgtStandardEnabled: false,
  cgtStandardFiltersEnabled: false,
  userId: 0,
  userSegment: '',
  isDownloadMyModelsEnabled: false,
  newRoyaltyUi: false,
  isSalesBoostEnabled: false,
  imageRestoreEnabled: false,
  isSubscriptionColumnEnabled: false,
  salesBoostPoints: 0,
  limitTagCampaignsAndCostInflation: false,
  sellerSuspensionAppealsEnabled: false,
}

export { Listing }
export default withRouter(Listing)
